import { API } from "../../../util/API";

// tslint:disable-next-line: no-unnecessary-class
export class CampaignDBService {
	static async sendEmailToDb(
		endpoint: string,
		email: string
	): Promise<{} | undefined> {
		try {
			const response: {} | undefined = await API.postReq(endpoint, email);
			// const response = undefined;

			return response;
		} catch (err) {
			console.warn(err);
		}
	}
}
